export enum APIRequestConfig {
  X_LOCALE = 'X-Locale',
  X_Requires_Registration_UUIDs = 'X-Requires-Registration-Uuids',
}
